export enum SupplierListTab {
  LIST = 'list',
  MAP = 'map',
}
